import { Spinner } from '@blueprintjs/core'
import React from 'react'
import styled from 'styled-components'
import { Overlay } from './Overlay'

export const Loading = styled(Overlay).attrs(() => ({
  children: <Spinner />,
}))``
